export const environment = {
  production: false,
  appTitle: 'Farco - Staging',
  apiUrl: 'https://farco.innovaitagence.com/api/v1',
  redirect_uri: 'https://farco.innovaitagence.com',
  recaptcha: {
    siteKey: '6LfA-aIZAAAAAHgTgCeMS1vlcclrdZ61vQ5SuWxg',
  },
  contactInfo: {
    phone: '+33631433618',
    email: 'contact@facingformations.com',
  }
}
